import { ConfigurationType } from 'data/types';

export function structureEditResetsDesigns(
  configurations: readonly ConfigurationType[],
  selectedSystems: readonly unknown[]
): boolean {
  return configurations.length > 0 || selectedSystems.length > 0;
}
